class CartPromoItem extends HTMLElement {
  constructor() {
    super();
  }

  get selectors() {
    return {
      variantSelect: "[data-gwp-variant]",
      addToCartButton: "[data-gwp-add-to-cart]"
    }
  }

  get attributes() {
    return {
      variantId: "data-gwp-variant-id"
    }
  }

  get modifiers() {
    return {
      variantSelectPlaceholder: "line-item__option--warning"
    }
  }

  connectedCallback() {
    this.addToCartElement = this.querySelector(this.selectors.addToCartButton);
    this.variantSelectElement = this.querySelector(this.selectors.variantSelect);

    this.addToCartElement.addEventListener("click", this.onAddToCartClick.bind(this));
    this.variantSelectElement.addEventListener("change", this.onVariantSelectChange.bind(this));
  }

  async onAddToCartClick(event) {
    event.preventDefault();

    const selectedOptionElement = this.variantSelectElement.querySelector("option:checked");

    const selectedVariantId = selectedOptionElement.getAttribute(this.attributes.variantId);

    if (!selectedVariantId) {
      return;
    }

    const cartData = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(selectedVariantId),
          quantity: 1,
          properties: {
            "_isGiftWithPurchase": true
          }
        }]
      })
    })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error(error);
      });

    document.dispatchEvent(new CustomEvent("cart:change", {
      detail: {
        cart: cartData
      }
    }));
  }

  onVariantSelectChange() {
    this.variantSelectElement.classList.remove(this.modifiers.variantSelectPlaceholder);

    this.addToCartElement.disabled = false;
    this.addToCartElement.innerText = theme.strings.product.add;
  }
}

if (!customElements.get("cart-promo-item")) {
  customElements.define("cart-promo-item", CartPromoItem);
}
